import { useMessageManagerProvider } from '../../../../../../../context/messageManager';
import { cn } from '../../../../../../../../utils/styles';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../components/Common/Icons/Icons';
import { Empty } from '../../index';
import { convertToAlphabetic } from '../../../../../../../../utils';
import QuillRichTextEditor from '../../../../../../Common/QuillRichTextEditor';

interface ITextModule {
  className?: string;
}

function TextModule({ className }: ITextModule) {
  const { selectedModule, handleSelectedModule, handleDispatch, handleIsTextOnly, state } = useMessageManagerProvider();

  const handleAdd = () => {
    if (!selectedModule?.item?.id) return;

    handleSelectedModule({
      ...selectedModule,
      item: {
        ...selectedModule.item,
        content: [...selectedModule.item.content, ''],
      },
    });
  };

  return (
    <div
      className={cn(
        'bg-lightGray2 min-h-[300px] border rounded-lg grid grid-rows-[auto,1fr] overflow-hidden',
        className
      )}
    >
      <div
        className={cn('bg-[#c6cfdb] p-[2px] pb-[3px]', {
          'bg-primary': state.step2.statement.mode === 'text',
        })}
      >
        <div
          className="flex gap-[3px] [&_button]:w-[44px] [&_button]:p-[10px]
        [&_button]:border-white [&_button]:border-[2px] [&_button]:bg-transparent [&_button]:text-white
        [&_button]:hover:text-white"
        >
          {selectedModule?.item?.content?.map((_, index) => (
            <Button
              key={`${index + 1}`}
              variant="outline"
              className={cn({
                '!bg-white !text-addition1 !hover:bg-white': selectedModule?.textTabIndex === index,
              })}
              onClick={() => {
                handleSelectedModule({
                  ...selectedModule,
                  textTabIndex: index,
                  imageTabIndex: undefined,
                });
                handleDispatch({
                  step2: {
                    ...state.step2,
                    statement: {
                      ...state.step2.statement,
                      mode: 'text',
                    },
                  },
                });
                handleIsTextOnly(true);
              }}
            >
              {convertToAlphabetic(index + 1)}
            </Button>
          ))}
          <Button className="!bg-transparent" onClick={handleAdd}>
            <Icons.PlusFilled className="mx-auto" />
          </Button>
        </div>
      </div>
      {selectedModule?.item?.content && state.step2.statement.mode === 'text' ? (
        <div className="bg-white">
          <div className="whitespace-pre-wrap">
            {selectedModule.textTabIndex !== undefined ? (
              <QuillRichTextEditor
                value={selectedModule?.item?.content[selectedModule.textTabIndex]}
                hideToolbar
                readOnly
              />
            ) : null}
          </div>
        </div>
      ) : (
        <Empty />
      )}
    </div>
  );
}

TextModule.defaultProps = {
  className: '',
};

export default TextModule;
